<template>
  <div class="c-clasp-color-selector l-flex">
    <div class="c-clasp-color-selector__container l-flex l-flex--column">
      <h1
        ref="headingToFocus"
        class="c-clasp-color-selector__title t-heading-5 u-margin-bottom-small"
        tabindex="0"
      >
        {{ step.personalizationTitle }}
      </h1>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="u-text-align-center u-margin-bottom-medium"
        v-html="step.personalizationDescription"
      />
      <!-- eslint-enable vue/no-v-html -->
      <swatch-list
        :product="product"
        :products="products"
        :render-link="false"
        :active-swatch="activeClasp"
        show-label-when="never"
        @input="selectClasp"
      />
      <btn
        :class-modifiers="step.button.fields.type"
        class="c-clasp-color-selector__next-btn u-margin-bottom-x-small"
        @click="incrementStep()"
      >
        {{ step.button.fields.text }} {{ nextStep.fields.personalizationTitle }}
      </btn>

      <btn
        type="link"
        url="#"
        @click="decrementStep"
      >
        BACK
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/button/Btn";
import SwatchList from '@/components/swatch/SwatchList'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { mapProduct, mapProducts } from "@/utils/shopifyHelper"

export default {
  name: "ClaspColorSelector",
  components: {
    Btn,
    SwatchList
  },
  props: {
    step: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      cta:{
        text: "BACK",
        type: "link"
      },
    }
  },
  computed: {
    ...mapState('braceletBuilder', [
      'bracelets',
      'clasps',
      'sleeves',
      'selections',
      'currentStep',
      'currentStepIndex'
    ]),
    ...mapGetters('braceletBuilder',[
      'loading',
      'nextStep',
      'claspFinish',
      'claspColor'
    ]),
    products() {
      return mapProducts(this.clasps);
    },
    product() {
      return mapProduct(this.selections.clasp);
    }
  },
  mounted() {
    const headingToFocus = this.$refs.headingToFocus;
    //console.log(headingToFocus)
    if (headingToFocus) {
      this.$refs.headingToFocus.focus();
    }
  },
  methods: {
    ...mapMutations('braceletBuilder', [
      'update'
    ]),
    ...mapActions('braceletBuilder',[
      'incrementStep',
      'decrementStep'
    ]),
    selectClasp(color) {
      if (color) {
        let clasp = this.clasps.find((clasp) => {
          return clasp.handle === color.handle
        })
        //check the currently selected finish type and update the correct variant
        return clasp.variants.find((variant)=> {
          if (variant.title === this.claspFinish) {
            return this.update({'clasp': variant});
          }
        })
      }
    },
    activeClasp(color) {
      return color.name === this.claspColor
    }
  },
}
</script>

<style lang="scss" scoped>
.c-clasp-color-selector {
  max-width: 100vw;
  height: 100%;
  width: 100%;
  &__container {
    max-width: rem(358px);
  }
  &__swatch {
    margin: 0 rem(2px);
    height: rem(65px);
  }
  &__next-btn {
    width: 100%;
    max-width: rem(344px);
  }
}

</style>
